/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { RECEIVE_COMMENTING_UNIT_CODE, FETCHING_COMMENTING_UNIT_CODE } from 'state/actions/commentingState/codeStatus';
import { transpileCommentingUnitCodeData } from 'state/reducers/commentingState/transpilers';


/* ========== ~~~~~~~~~~  CONFIG : REDUCER ~~~~~~~~~~ ========== */
//transpiler


// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = transpileCommentingUnitCodeData({});


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
const codeStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case RECEIVE_COMMENTING_UNIT_CODE:
            newState.commentingUnitCode = transpileCommentingUnitCodeData(action.data);
            return newState;
        case FETCHING_COMMENTING_UNIT_CODE:
            newState.fetchingCommentingUnitCode = action.status;
            return newState;
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default codeStatus;
